import React, { useState, useReducer } from 'react';

// components
import { Row, Col, Button, Collapse, Spinner } from "reactstrap";
import ProgressBar from 'components/ProgressBar/ProgressBar';

// helpers
import { uuidv4 } from '../../helpers/uuid';
import { formateDateAndTimeApi } from '../../helpers/formats';
import { showMessage, showQuestion } from "../../helpers/message.js";
import { getSessionCookie } from "../../helpers/cookies";

// api
import formulariovistoria_api from "../../api/formulariovistoria_api.js";
import boletimvistoria_api from "../../api/boletimvistoria_api.js";

// views
import VistoriaOnlineIdentificacao from './Components/VistoriaOnlineIdentificacao';
import VistoriaOnlineCabecalho from './Components/VistoriaOnlineCabecalho';
import VistoriaOnlineInspecao from './Components/VistoriaOnlineInspecao';
import VistoriaOnlineListaInspecoes from './Components/VistoriaOnlineListaInspecoes';

export default function VistoriaOnline({ history }) {

    const [showLoading, setshowLoading] = React.useState(false);

    const [stepFormulario, set_stepFormulario] = useState(0);
    const [showInspecoesRealizadas, set_showInspecoesRealizadas] = useState(false);
    const session = getSessionCookie();

    const initialState = {
        boletimVistoria_Id: 0,
        contrato_Id: null,
        formularioVistoria_Id: null,
        formularioVistoria: null,
        usuarioFiscal_Id: session.usuario_Id,
        dataHoraInicio: null,
        regional_Id: null,
        concessionaria_Id: null,
        hash: uuidv4(),
        boletimVistoriaCabecalhos: [],
        boletimVistoriaInspecoes: [],
        boletinsVinculados: []
    }

    const [state, dispatch] = useReducer(reducer, initialState);
    function reducer(state, action) {
        switch (action.type) {
            case 'reset':
                return {
                    ...state,
                    formularioVistoria_Id: null,
                    formularioVistoria: null,
                    dataHoraInicio: null,
                    regional_Id: null,
                    concessionaria_Id: null,
                    hash: uuidv4(),
                    boletimVistoriaCabecalhos: [],
                    boletimVistoriaInspecoes: [],
                }
            case 'iniciar':
                return {
                    ...state,
                    formularioVistoria_Id: action.data.formularioVistoria_Id,
                    formularioVistoria: action.formularioVistoria,
                    dataHoraInicio: formateDateAndTimeApi(new Date()),
                    regional_Id: action.data.regional_Id,
                    concessionaria_Id: action.data.concessionaria_Id,
                    boletimVistoriaVinculos: action.data.boletinsVinculados,
                    contrato_Id: action.data.contrato_Id
                }
            case 'cabeçalho':
                return {
                    ...state,
                    boletimVistoriaCabecalhos: action.boletimVistoriaCabecalhos,
                }
            case 'inspeção':
                return {
                    ...state,
                    boletimVistoriaInspecoes: action.boletimVistoriaInspecoes
                }
        }
    }

    const handleInciarBoletimVistoria = (identificacao) => {
        formulariovistoria_api.getItemFromWeb(identificacao.formularioVistoria_Id).then(result => {
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                dispatch({ type: 'iniciar', data: identificacao, formularioVistoria: result.data })
                set_stepFormulario(1);
            }
        });
    }

    const handleAvancarCabecalho = (cabecalho) => {
        dispatch({ type: 'cabeçalho', boletimVistoriaCabecalhos: cabecalho });
        set_stepFormulario(2);
    }

    const handleFinalizarInspecao = (inspecao) => {
        dispatch({ type: 'inspeção', boletimVistoriaInspecoes: [...state.boletimVistoriaInspecoes, inspecao] });
        if (state.boletimVistoriaInspecoes.length + 1 == state.formularioVistoria.totalInspecoesVistoria) {
            set_stepFormulario(3);
            set_showInspecoesRealizadas(true);
        }
    }

    const handleCancelar = () => {
        showQuestion("Atenção", "Tem certeza que quer cancelar o boletim em andamento?", "question", function (success) {
            if (success) {
                set_stepFormulario(0);
                dispatch({ type: 'reset' });
            }
        });
    }

    const handleFinalizarBoletim = () => {
        setshowLoading(true);
        let json_submit = state;
        json_submit.dataHoraFim = formateDateAndTimeApi(new Date());

        let boletimVistoriaVinculos = [];

        json_submit.boletimVistoriaVinculos.map(m => {
            boletimVistoriaVinculos.push({
                boletimVistoriaVinculado: m.boletimVistoria_Id
            });
        })

        json_submit.boletimVistoriaVinculos = boletimVistoriaVinculos;

        boletimvistoria_api.post(json_submit).then(result => {
            setshowLoading(false);
            if (result.status !== 200) {
                showMessage("Aviso", result.message, 'error', null);
            }
            else {
                showMessage("Aviso", "Boletim de Vistoria criado com sucesso!", 'success', function () {
                    dispatch({ type: 'reset' });
                    set_stepFormulario(0);
                });
            }
        });
    }

    return (
        <>
            {showLoading &&
                <div className="carregandoCmp">
                    <div className="box">
                        <Spinner></Spinner>
                    </div>
                </div>
            }
            <div className="content">
                <Row>
                    <Col md="12">
                        <ProgressBar steps={["Identificação", "Cabeçalho", "Inspeções", "Finalização"]} stepValue={stepFormulario}></ProgressBar>
                    </Col>
                </Row>
                {state.boletimVistoriaInspecoes.length > 0 &&
                    <>
                        <Row>
                            <Col md="12" className="text-right">
                                <Button className="btn-link" onClick={() => set_showInspecoesRealizadas(!showInspecoesRealizadas)}>
                                    <i className={showInspecoesRealizadas ? "fas fa-chevron-down fa-cursor" : "fas fa-chevron-up fa-cursor"}></i>
                                    Inspeções Realizadas ({state.boletimVistoriaInspecoes.length + "/" + state.formularioVistoria.totalInspecoesVistoria})
                                </Button>
                            </Col>
                        </Row>
                        <Collapse isOpen={showInspecoesRealizadas}>
                            <VistoriaOnlineListaInspecoes
                                boletimVistoriaInspecoes={state.boletimVistoriaInspecoes}
                            />
                        </Collapse>
                    </>
                }

                {stepFormulario == 0 &&
                    <VistoriaOnlineIdentificacao
                        handleAvancar={handleInciarBoletimVistoria}
                    />
                }
                {stepFormulario == 1 &&
                    <VistoriaOnlineCabecalho
                        formularioVistoria={state.formularioVistoria}
                        handleAvancar={handleAvancarCabecalho}
                        handleCancelar={handleCancelar}
                        boletinsVinculados={state.boletimVistoriaVinculos}
                    />
                }
                {stepFormulario == 2 &&
                    <VistoriaOnlineInspecao
                        key={state.boletimVistoriaInspecoes.length}
                        formularioVistoria={state.formularioVistoria}
                        handleFinalizarInspecao={handleFinalizarInspecao}
                        handleCancelar={handleCancelar}
                        boletinsVinculados={state.boletimVistoriaVinculos}
                    />
                }
                {stepFormulario == 3 &&
                    <Row>
                        <Col lg="12" md="12" sm="12" className="text-center">
                            <Button color="default" type="button" onClick={handleCancelar}>
                                Cancelar
                            </Button>
                            <Button color="success" type="button" onClick={handleFinalizarBoletim}>
                                <i className="fas fa-save"></i>  Finalizar Boletim
                            </Button>
                        </Col>
                    </Row>
                }
            </div>
        </>
    );
}

